export const ALTUS_ORGANIZATION_CODE = 'ALTUS';
